import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let event_type = useDataValue({
    context: 'automation',
    path: 'event_type',
    viewPath: props.viewPath,
  })
  let action_index = useDataValue({
    context: 'event_action_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let actions = useDataValue({
    context: 'automation',
    path: 'actions',
    viewPath: props.viewPath,
  })
  let trigger_type = useDataValue({
    context: 'automation',
    path: 'trigger_type',
    viewPath: props.viewPath,
  })
  let automation_type = useDataValue({
    context: 'automation',
    path: 'automation_type',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    let items = data.items.filter(({ supported_event_types }) =>
      supported_event_types.includes(event_type)
    )
    return { ...data, items }
  }, [data, event_type, automation_type, trigger_type, actions, action_index])
}
